import Vue from "vue";
import {format, parseISO} from "date-fns";
import {de} from "date-fns/locale";

Vue.filter('formatLocaleDate', (date) => {
    return  date ? format(parseISO(date), 'PP', {locale: de}) : ''
})
Vue.filter('formatLocaleDateTime', (date) => {
    return  date ? (format(parseISO(date), 'dd.MM.yyyy HH:mm', {locale: de}) + ' Uhr') : ''
})
Vue.filter('uppercaseFirstLetter', (string) => {
    return string ? string.charAt(0).toUpperCase() : ''
})


